<account-back [link]="'/account/edit'">{{ sectionTitle }}</account-back>

@if (source) {
  <account-form>
    <p class="p1">{{ inFormTitle }}</p>
    <!-- prefix -->
    <div class="m-t-5">
      <ng-content></ng-content>
    </div>
    <!-- submission -->
    <div class="m-t-9 "
      sizeClass="SM:flex flex-column-reverse">
      <button class="button-1 c-6 c-12-s c-12-m m-b-0 m-t-5-m m-t-5-s"
        (click)="source.close()">{{'Cancel' |translate}}
      </button>
      <action class="button c-6 c-12-s c-12-m  m-b-0 m-r-0"
        (click)="source.submit()"
        [status]="source.status">
        {{ 'Save changes' | translate }}
      </action>
    </div>
    <result [status]="source.status"
    [success]="'Your account data has been saved'"></result>
  </account-form>
}